import { restApi } from '~features/api/restApiSlice';

type TrialPerformance = {
  averageDeliveryTime: number | null;
  originalDeliveryTime: number | null;
  apiRequests: number | null;
};

export const freeTrialApiSlice = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getTrialPerformance: builder.query<TrialPerformance | null, void>({
      query: () => ({
        url: '/v3/aggregated-metrics/trial-overview',
      }),
      transformResponse: (response: { data: TrialPerformance }) => {
        return response.data;
      },
    }),
  }),
});

export const { useLazyGetTrialPerformanceQuery } = freeTrialApiSlice;
